var React = require('react');

function Sort (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M100.78-201.56V-307h268.83v105.44H100.78Zm0-225.44v-105.44h513.35V-427H100.78Zm0-225.44v-105.43h758.44v105.43H100.78Z"}));
}

Sort.defaultProps = {"height":"24","viewBox":"0 -960 960 960","width":"24"};

module.exports = Sort;

Sort.default = Sort;
